import { render, staticRenderFns } from "./PaidPlanAdsModal.vue?vue&type=template&id=d81bb8f6&scoped=true&lang=pug"
import script from "./PaidPlanAdsModal.vue?vue&type=script&lang=ts"
export * from "./PaidPlanAdsModal.vue?vue&type=script&lang=ts"
import style0 from "./PaidPlanAdsModal.vue?vue&type=style&index=0&id=d81bb8f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d81bb8f6",
  null
  
)

export default component.exports